import React from "react"

const Distributions = () => {
  return (
    <>
      <section className="features bg-light">
        <div className="container-xl">
          <h3 className="component-title">Distributions</h3>
          <div className="description mb-4">
            Deploy servers with choice of operating system, Easily Deploy &
            Scale, Customize with Confidence
          </div>
          <div className="row gy-4">
            <div className="col-6 col-md-3">
              <div className="card border-0 card-shadow mb-3 py-3 h-100 justify-content-center align-items-center">
                <img
                  src="/img/os/windows.svg"
                  alt="Windows"
                  width="64"
                  height="64"
                />
                <h4 className="mb-0 mt-3 card-title">Windows</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 card-shadow mb-3 py-3 h-100 justify-content-center align-items-center">
                <img
                  src="/img/os/ubuntu.svg"
                  alt="Ubuntu"
                  width="64"
                  height="64"
                />
                <h4 className="mb-0 mt-3 card-title">Ubuntu</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 card-shadow mb-3 py-3 h-100 justify-content-center align-items-center">
                <img
                  src="/img/os/fedora.svg"
                  alt="fedora"
                  width="64"
                  height="64"
                />
                <h4 className="mb-0 mt-3 card-title">Fedora</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 card-shadow mb-3 py-3 h-100 justify-content-center align-items-center">
                <img
                  src="/img/os/debian.svg"
                  alt="debian"
                  width="64"
                  height="64"
                />
                <h4 className="mb-0 mt-3 card-title">Debian</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 card-shadow mb-3 py-3 h-100 justify-content-center align-items-center">
                <img
                  src="/img/os/almalinux.svg"
                  alt="Alma Linux"
                  width="64"
                  height="64"
                />
                <h4 className="mb-0 mt-3 card-title">Alma Linux</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 card-shadow mb-3 py-3 h-100 justify-content-center align-items-center">
                <img
                  src="/img/os/rockylinux.svg"
                  alt="Rocky Linux"
                  width="64"
                  height="64"
                />
                <h4 className="mb-0 mt-3 card-title">Rocky Linux</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 card-shadow mb-3 py-3 h-100 justify-content-center align-items-center">
                <img
                  src="/img/os/opensuse.svg"
                  alt="OpenSUSE"
                  width="64"
                  height="64"
                />
                <h4 className="mb-0 mt-3 card-title">OpenSUSE</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 card-shadow mb-3 py-3 h-100 justify-content-center align-items-center">
                <img
                  src="/img/os/centos.svg"
                  alt="CentOS"
                  width="64"
                  height="64"
                />
                <h4 className="mb-0 mt-3 card-title">CentOS</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Distributions
